import { Url, Http, Auth } from '@intelipost-js/secure-providers';

export default {
  getUrlProvider(context, providerName) {
    return Http.get(Url.toQueryString('/api/v1/openid/authorize_url', null, [providerName]))
      .then(res => res.data.content.url);
  },
  loginWithProviderToken(context, token) {
    return Http.request({
      url: '/api/v1/openid/authenticate',
      headers: {
        Authentication: `Bearer ${token}`,
      },
    })
      .then((res) => {
        Auth.updateUser(res.data.content);
        return Auth.setMenu();
      });
  },
};



// WEBPACK FOOTER //
// ./src/features/public/login/openid/store/actions.js